import { useContext } from "react"
import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { Box, Button, Typography } from '@mui/material'
import OneModal from "../../../../../Components/OneModal/OneModal"
import { WebSocketContext } from "../../../../../Providers/WebSocket/WebSocketContext"

const RondaModalDelete = ({ open, setOpen, title, eventId, rondaId, setRenderizarRonda }) => {
    const { sendWs, addRoute } = useContext(WebSocketContext)

    const rondaExcluidaSucesso = (msg) => {
        const { status } = msg.data

        if (status) {
            setOpen(false)
            setRenderizarRonda(false)
        }
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleDelete = () => {
        sendWs("deletaRonda", { rondaId })
        addRoute("deletaRonda", rondaExcluidaSucesso)
    }
    return (
        <OneModal
            open={open}
            setOpen={handleClose}
            titleText={title}
        >
            <Grid container sx={{ flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <Typography>Tem certeza que deseja excluir essa ronda?</Typography>
                <Box sx={{ width: '100%', paddingTop: '15px', display: 'flex', justifyContent: 'space-between' }}>
                    <Button variant="contained" color="error" onClick={() => handleClose()} size="small">Não</Button>
                    <Button variant="contained" color="success" onClick={handleDelete} size="small">Sim</Button>
                </Box>
            </Grid>
        </OneModal>
    )
}

export default RondaModalDelete
